export const defaultProps = {
  pathName: '[[router.locationBeforeTransitions.pathname]]',
  ctSessionId: '[[analyticsReducer.ct_session_id]]'
};
